import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, makeStyles } from '@material-ui/core'
import { CopyMoveModalStypeProps } from './CopyMoveModal'

const useStyles = makeStyles((theme: Theme) => ({
    dialogTitle: {
        '& .MuiTypography-h6': {
            fontSize: pxToRem(22),
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        '&.MuiDialogTitle-root': {
            paddingLeft: (props: CopyMoveModalStypeProps) =>
                theme.spacing(props.isForAssociation ? 3 : 0),
            paddingRight: theme.spacing(0),
        },
        borderBottom: (props: CopyMoveModalStypeProps) =>
            !props.removeHeaderBorder ? '1px solid #A7ACA8' : 'none',
    },
    dialogTitlePadding: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(3),
    },
    forAssociation: {
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        maxWidth: 1020,
    },
    dialogCont: {
        color: theme.palette.common.black,
        '@media (max-width: sm)': {
            width: 250,
        },
        '&.MuiDialogContent-root': {
            paddingLeft: (props: CopyMoveModalStypeProps) =>
                theme.spacing(props.isForAssociation ? 3 : 0),
            paddingRight: (props: CopyMoveModalStypeProps) =>
                theme.spacing(props.isForAssociation ? 3 : 0),
        },
        fontSize: pxToRem(18),
        borderBottom: (props: CopyMoveModalStypeProps) =>
            !props.removeFooterBorder ? '1px solid #A7ACA8' : 'none',
    },
    addContentOverflow: {
        overflowY: 'auto',
    },
    dialogContSmall: {
        '&.MuiDialogContent-root': {
            width: pxToRem(700),
            height: pxToRem(550),
        },
    },
    dialogContDefault: {
        '&.MuiDialogContent-root': {
            width: pxToRem(500),
            height: 'auto',
        },
    },

    actionButton: {
        color: '#fff',
        fontSize: pxToRem(18),
        width: 108,
        background: '#d3455b',
        marginBottom: theme.spacing(0.5),
        '&:hover': {
            backgroundColor: '#e9a2ad',
        },
    },

    actionButtonBulk: {
        fontSize: pxToRem(18),
        width: 108,
        marginBottom: theme.spacing(0.5),
        '&:hover': {
            cursor: 'pointer',
        },
    },
    actionButtonImportOnly: {
        color: '#A78966',
        fontSize: pxToRem(18),
        width: 130,
        marginBottom: theme.spacing(16),
    },
    confirmationText: {
        paddingTop: theme.spacing(2),
        fontSize: pxToRem(18),
        color: theme.palette.common.black,
    },
    warningDialogCont: {
        '& .MuiDialog-paperScrollPaper': {
            paddingLeft: (props: CopyMoveModalStypeProps) =>
                theme.spacing(props.isForAssociation ? 0 : 3),
            paddingRight: (props: CopyMoveModalStypeProps) =>
                theme.spacing(props.isForAssociation ? 0 : 3),
            maxHeight: '95vh',
        },
    },
    dialogAction: {
        '&.MuiDialogActions-root': {
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
        },
    },
    detailText: {
        fontSize: pxToRem(11),
    },
    circularProgressCenter: {
        position: 'absolute',
        left: '50%',
        top: '50%',
    },
    marginAuto: {
        margin: 'auto',
    },
}))

export default useStyles
